"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _PriceBreakDownCardPopOver = require("./PriceBreakDownCardPopOver.proptypes");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable eqeqeq */
// eslint-disable-next-line react/prop-types


var Container = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__Container",
  componentId: "sc-1tmc84a-0"
})(["position:relative;"]);

var Heading = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__Heading",
  componentId: "sc-1tmc84a-1"
})(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize.normal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.lineHeight.XLarge;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeight.bold;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.charcoalGrey;
});

var Highlight = _styledComponents.default.span.withConfig({
  displayName: "PriceBreakDownPopOver__Highlight",
  componentId: "sc-1tmc84a-2"
})(["margin:0 0.3em;color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.tertiary;
});

var DetailRow = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__DetailRow",
  componentId: "sc-1tmc84a-3"
})(["display:flex;justify-content:space-between;font-size:", ";margin-bottom:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.micro;
});

var FinalRow = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__FinalRow",
  componentId: "sc-1tmc84a-4"
})(["display:flex;align-items:center;justify-content:space-between;font-size:", ";margin-bottom:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize.normal;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.micro;
});

var Detail = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__Detail",
  componentId: "sc-1tmc84a-5"
})(["font-size:", ";};color:", ";font-weight:", ";font-family:", ";display:flex;align-items:baseline;width:", ";"], function (_ref11) {
  var isTotal = _ref11.isTotal,
      theme = _ref11.theme;
  return isTotal ? theme.fontSize.titleSmall : theme.fontSize.small;
}, function (_ref12) {
  var isGreen = _ref12.isGreen,
      theme = _ref12.theme;
  return isGreen ? theme.colors[isGreen] : theme.colors.greyDark;
}, function (_ref13) {
  var isBold = _ref13.isBold,
      theme = _ref13.theme;
  return isBold ? theme.fontWeight.bold : theme.fontWeight.normal;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontFamily.default;
}, function (_ref15) {
  var width = _ref15.width;
  return width;
});

var Currency = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__Currency",
  componentId: "sc-1tmc84a-6"
})(["font-size:", "!important;display:flex;align-items:center;margin-right:", ";color:", ";margin-top:", ";};font-weight:", ";font-family:", ";line-height:", ";"], function (_ref16) {
  var isTotal = _ref16.isTotal,
      theme = _ref16.theme;
  return isTotal ? theme.fontSize.small : theme.space.small;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.nano;
}, function (_ref18) {
  var isGreen = _ref18.isGreen,
      theme = _ref18.theme;
  return isGreen ? theme.colors[isGreen] : theme.colors.greyDark;
}, function (_ref19) {
  var isTotal = _ref19.isTotal,
      theme = _ref19.theme;
  return isTotal ? theme.space.nano : theme.space.none;
}, function (_ref20) {
  var isBold = _ref20.isBold,
      theme = _ref20.theme;
  return isBold ? theme.fontWeight.bold : theme.fontWeight.normal;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontFamily.default;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.lineHeight.small;
});

var DetailSummary = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__DetailSummary",
  componentId: "sc-1tmc84a-7"
})(["font-size:", ";display:flex;color:", ";font-family:", ";align-items:baseline;width:", ";justify-content:", ";line-height:", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontSize.XSmall;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.greyDark;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontFamily.default;
}, function (_ref26) {
  var width = _ref26.width;
  return width;
}, function (_ref27) {
  var flex = _ref27.flex;
  return flex;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.lineHeight.XXSmall;
});

var RoomType = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__RoomType",
  componentId: "sc-1tmc84a-8"
})(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";"], function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontFamily.default;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.fontSize.normal;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.lineHeight.XLarge;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.fontWeight.bold;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.colors.greyDarker;
});

var TotalRow = (0, _styledComponents.default)(DetailRow).withConfig({
  displayName: "PriceBreakDownPopOver__TotalRow",
  componentId: "sc-1tmc84a-9"
})(["margin-top:", ";border:1px solid ", ";margin-bottom:", ";"], function (_ref34) {
  var theme = _ref34.theme;
  return theme.space.small;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.charcoalGrey;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.XXXSmall;
});
var IntenseOutlineRow = (0, _styledComponents.default)(DetailRow).withConfig({
  displayName: "PriceBreakDownPopOver__IntenseOutlineRow",
  componentId: "sc-1tmc84a-10"
})(["margin-top:", ";border:2px solid ", ";"], function (_ref37) {
  var theme = _ref37.theme;
  return theme.space.small;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.colors.charcoalGrey;
});

var RectangleBox = _styledComponents.default.div.withConfig({
  displayName: "PriceBreakDownPopOver__RectangleBox",
  componentId: "sc-1tmc84a-11"
})(["padding:8px 12px;background-color:", ";display:flex;flex-direction:column;gap:", ";box-sizing:border-box;justify-content:center;margin-top:", ";margin-bottom:", ";"], function (_ref39) {
  var theme = _ref39.theme;
  return theme.colors.lightRed;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.space.tiny;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.space.small;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.space.small;
});

var PriceBreakDownPopOver = function PriceBreakDownPopOver(_ref43) {
  var totalFlightSAPriceKey = _ref43.totalFlightSAPriceKey,
      totalHotelSAPriceKey = _ref43.totalHotelSAPriceKey,
      bundleSavingKey = _ref43.bundleSavingKey,
      totalFlightSAPrice = _ref43.totalFlightSAPrice,
      totalHotelSAPrice = _ref43.totalHotelSAPrice,
      bundleSavingPrice = _ref43.bundleSavingPrice,
      totalBundlePrice = _ref43.totalBundlePrice,
      totalPayableText = _ref43.totalPayableText,
      perGuest = _ref43.perGuest,
      summaryNightKey = _ref43.summaryNightKey,
      savingLabel = _ref43.savingLabel,
      subLabel = _ref43.subLabel,
      currency = _ref43.currency,
      theme = _ref43.theme,
      comboMessage = _ref43.comboMessage,
      totalText = _ref43.totalText,
      totalSAPrice = _ref43.totalSAPrice,
      perPersonBundlePrice = _ref43.perPersonBundlePrice;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var escapedComboMessage = comboMessage === null || comboMessage === void 0 ? void 0 : comboMessage.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  var splitPattern = new RegExp("(".concat(escapedComboMessage, ")"), 'i');
  var headlineParts = savingLabel === null || savingLabel === void 0 ? void 0 : savingLabel.split(splitPattern);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        flex: '1'
      }
    }, /*#__PURE__*/_react.default.createElement(Heading, null, headlineParts[0]), /*#__PURE__*/_react.default.createElement(Heading, null, /*#__PURE__*/_react.default.createElement(Highlight, null, headlineParts[1])), /*#__PURE__*/_react.default.createElement(Heading, null, headlineParts[2])), /*#__PURE__*/_react.default.createElement(RectangleBox, null, /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(RoomType, null, subLabel)), /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(Detail, {
      width: "50%"
    }, totalFlightSAPriceKey), /*#__PURE__*/_react.default.createElement(Detail, null, currency, " ", totalFlightSAPrice)), /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(Detail, {
      width: "50%"
    }, totalHotelSAPriceKey), /*#__PURE__*/_react.default.createElement(Detail, null, currency, " ", totalHotelSAPrice)), /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(Detail, {
      width: "50%",
      isGreen: "greyDarker"
    }, totalText), /*#__PURE__*/_react.default.createElement(Detail, {
      isGreen: "greyDarker"
    }, currency, " ", totalSAPrice))), bundleSavingPrice !== null && bundleSavingPrice !== '' && bundleSavingPrice != 0 && /*#__PURE__*/_react.default.createElement(DetailRow, null, /*#__PURE__*/_react.default.createElement(Detail, {
      isBold: true,
      isGreen: "tertiary",
      width: "50%"
    }, bundleSavingKey), /*#__PURE__*/_react.default.createElement(Detail, {
      isBold: true,
      isGreen: "tertiary"
    }, "- ", currency, " ", bundleSavingPrice)), /*#__PURE__*/_react.default.createElement(TotalRow, null), /*#__PURE__*/_react.default.createElement(FinalRow, null, /*#__PURE__*/_react.default.createElement(Detail, {
      isBold: true,
      isGreen: "neutral",
      width: "50%"
    }, totalPayableText), /*#__PURE__*/_react.default.createElement(Detail, {
      isBold: true,
      isTotal: true,
      isGreen: "neutral"
    }, /*#__PURE__*/_react.default.createElement(Currency, {
      isTotal: true,
      isGreen: "neutral"
    }, currency), totalBundlePrice)), /*#__PURE__*/_react.default.createElement(FinalRow, null, /*#__PURE__*/_react.default.createElement(DetailSummary, {
      width: "55%"
    }, summaryNightKey), /*#__PURE__*/_react.default.createElement(DetailSummary, {
      width: "50%",
      flex: "flex-end"
    }, perPersonBundlePrice && currency, " ", perPersonBundlePrice, " ", perGuest)), /*#__PURE__*/_react.default.createElement(IntenseOutlineRow, null));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

PriceBreakDownPopOver.propTypes = _PriceBreakDownCardPopOver.PriceBreakDownPopOverPropTypes;
PriceBreakDownPopOver.defaultProps = _PriceBreakDownCardPopOver.PriceBreakDownPopOverDefaultPropTypes;
var _default = PriceBreakDownPopOver;
exports.default = _default;